import { ButtonHTMLAttributes } from "react";
import { cn } from "~/design-system/lib/utils";

export type ButtonPropsType = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "text" | "contained" | "outlined";
  buttonColor?: "primary" | "secondary" | "transparent";
};

const baseStyles =
  "btn w-full rounded-xl px-2 sm:px-4 sm:py-3 py-2 text-sm sm:fluid-text-base font-semibold duration-200";

const variantStyles = {
  text: "bg-transparent",
  contained: "shadow text-white",
  outlined: "bg-transparent border",
};

const colorStyles = {
  primary: {
    text: "text-primary hover:bg-primary-hover",
    contained: "bg-primary hover:bg-primary-hover text-white",
    outlined:
      "border-primary text-primary hover:bg-primary-hover hover:text-white",
  },
  secondary: {
    text: "text-secondary hover:bg-secondary-hover",
    contained: "bg-secondary hover:bg-secondary-hover text-white",
    outlined:
      "border-secondary text-secondary hover:bg-secondary-hover hover:text-white",
  },
  transparent: {
    text: "text-black hover:bg-light-primary hover:text-white",
    contained:
      "bg-transparent text-black hover:bg-light-primary hover:text-white",
    outlined: "border-none text-black hover:bg-light-primary hover:text-white",
  },
};

export function Button({
  children,
  className,
  variant = "contained",
  buttonColor = "primary",
  ...props
}: ButtonPropsType) {
  return (
    <button
      {...props}
      className={cn(
        baseStyles,
        variantStyles[variant],
        colorStyles[buttonColor][variant],
        className,
      )}
    >
      {children}
    </button>
  );
}
